module.exports = __webpack_public_path__ + "img/poalim.f7eb6f7d.jpg";